<button mat-icon-button class="sort-btn" (click)="onClick.emit(columnName)">
  <fa-duotone-icon *ngIf="appliedSorting?.column !== columnName" [icon]="['fad', 'sort']"></fa-duotone-icon>
  <fa-duotone-icon
    *ngIf="appliedSorting?.column === columnName"
    [icon]="['fad', 'sort-down']"
    [flip]="appliedSorting?.reverse && 'vertical'">
  </fa-duotone-icon>
</button>
